export const defaultSEOConfig = {
  title: "Ploughman's Deli & Cafe - Award-Winning Sandwiches | Oak Forest, Houston, TX",
  description: "Ploughman's Deli & Cafe is a sci-fi and fantasy themed deli serving award-winning sandwiches in Oak Forest, Houston, TX 77018. Voted among Houston's best sandwich shops, serving Garden Oaks, Candlelight Oaks, and Shepherd Park Plaza.",
  keywords: "ploughmans deli, deli houston, best sandwiches houston, oak forest deli, garden oaks restaurant, candlelight oaks, shepherd park plaza, houston sandwich shop, themed restaurant, sci-fi restaurant, fantasy deli, 77018 deli, pinemont dr",
  url: "https://ploughmansdeli.com",
  image: "https://ploughmansdeli.com/og-image.jpg",
  siteName: "Ploughman's Deli & Cafe",
  locale: "en_US",
  openGraph: {
    type: "restaurant.restaurant",
    title: "Ploughman's Deli & Cafe - Houston's Award-Winning Sandwich Quest",
    description: "Award-winning sandwiches in Oak Forest, Houston. A sci-fi and fantasy themed deli serving Garden Oaks, Candlelight Oaks, and Shepherd Park Plaza."
  },
  twitter: {
    card: "summary_large_image",
    title: "Ploughman's Deli & Cafe - Award-Winning Sandwiches in Houston",
    description: "A sci-fi and fantasy themed deli serving award-winning sandwiches in Oak Forest, Houston, TX."
  }
};